/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcMutualfundsV1MutualFundsTaskEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_MUTUALFUNDS_V1_MUTUAL_FUNDS_TASK_EVENT_ENTITY_NAME = 'ixc.mutualfunds.v1.MutualFundsTaskEvent';
export const ixcMutualfundsV1MutualFundsTaskEventEntity = new schema.Entity<IxcMutualfundsV1MutualFundsTaskEvent>(IXC_MUTUALFUNDS_V1_MUTUAL_FUNDS_TASK_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcMutualfundsV1MutualFundsTaskEvent) => `${entity.metadata?.eventId}` });

